import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./keymodal.css";
import { Save, SquarePen } from "lucide-react";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";

const CredoModal = ({ isOpen, onClose, isDateOlderThanToday }) => {
  const [credo, setCredo] = useState("");
  const [editCredo, setEditCredo] = useState(false);

  useEffect(() => {
    const fetchCredo = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/credo", {});
        if (res.status) {
          setCredo(res.data.statement);
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };
    fetchCredo();
  }, [isOpen]);

  const saveCredo = async (e) => {
    e.preventDefault();

    if (!credo) {
      toastr.error("Please fill the Credo");
      return;
    }

    const payload = {
      statement: credo,
      progress: 100,
    };

    try {
      const res = await apiServiceHandler("POST", "api/credo", payload);
      if (res.status) {
        toastr.success(res.message);
        onClose();
        setCredo("");
        setEditCredo(false);
      }
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  const handleEditCredo = () => {
    setEditCredo(true);
  };

  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton style={{ borderBottom: "none" }}>
        <Modal.Title>CREDO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="edit-key">
          <textarea
            className="key-input"
            placeholder="CREDO"
            readOnly={!editCredo}
            value={credo}
            onClick={handleEditCredo}
            onChange={(e) => setCredo(e.target.value)}
            style={editCredo ? { background: "#f3f4f6" } : {}}
          />
          {!isDateOlderThanToday && (
            <div
              className="square-pen"
              onClick={!editCredo ? handleEditCredo : saveCredo}
              style={{ top: "0" }}
            >
              {!editCredo ? <SquarePen size={16} /> : <Save size={16} />}
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ borderTop: "none", paddingTop: "1rem" }} />
    </Modal>
  );
};

export default CredoModal;
